module.exports = __webpack_public_path__ + "static/media/iguazu-falls-37.75986554.jpg";